import React from 'react';

import { DialogContent, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

import Dialog from 'src/components/ui/Dialog';
import DialogTitle from 'src/components/ui/DialogTitle';
import Typography from 'src/components/ui/Typography';
import IconButton from 'src/components/ui/IconButton';

import { colours } from 'src/constants/colours';

import { breakpoints } from 'src/constants/breakpoints';
import { ReasonForLess } from 'src/types/__generated__/graphql';
import { styledComponent } from 'src/utils/styled';

const StyledDialog = styledComponent(Dialog)`
    width: fit-content;
    margin: auto;
    .MuiPaper-root {
        padding: 1rem;
        height: 20rem;
    }
    @media (max-width: ${breakpoints.tabletPortrait - 1}px) {
        width: 100vw;
        .MuiPaper-root {
            padding: 0;
            width: 100%;
            height: 100%;
            max-height: 100%;
            margin: 0;
            border-radius: 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;

const StyledDialogContent = styledComponent(DialogContent)`
    width: 22.75rem;
`;

const StyledFormControlLabel = styledComponent(FormControlLabel)`
    .Mui-checked {
        ~ .MuiFormControlLabel-label {
            font-weight: bold;
        }
    }
`;

const CloseButton = styledComponent(IconButton)`
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 10;
    padding: 0.2rem;
    background-color: ${colours.white.main};
`;

type Props = {
    open: boolean;
    onClose: () => void;
    onFeedbackChosen: (feedback: ReasonForLess) => void;
};

const SendNewsFeedbackModal: React.FC<Props> = ({ open, onClose, onFeedbackChosen }) => {
    const { t } = useTranslation(['news']);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let feedback: ReasonForLess;
        switch (e.target.name) {
            case ReasonForLess.Repetitive:
                feedback = ReasonForLess.Repetitive;
                break;
            case ReasonForLess.NotInteresting:
                feedback = ReasonForLess.NotInteresting;
                break;
            case ReasonForLess.Enough:
                feedback = ReasonForLess.Enough;
                break;
            default:
                feedback = ReasonForLess.Default;
        }
        onFeedbackChosen(feedback);
    };

    const closeModal = () => {
        onClose();
    };
    return (
        <StyledDialog open={open}>
            <Box>
                <CloseButton
                    color="white"
                    onClick={closeModal}
                    iconProps={{
                        name: 'Close',
                    }}
                />
                <DialogTitle>
                    <Typography variant="h3">{t(`news:newsPost:reasonForLess:modalTitle`)}</Typography>
                </DialogTitle>
                <StyledDialogContent>
                    <Typography variant="body1">{t(`news:newsPost:reasonForLess:modalDescription`)}</Typography>
                    <RadioGroup onChange={handleChange} defaultValue={ReasonForLess.Default}>
                        <StyledFormControlLabel
                            name={ReasonForLess.NotInteresting}
                            value={ReasonForLess.NotInteresting}
                            label={t('news:newsPost:reasonForLess:notInteresting')}
                            control={<Radio />}
                        />
                        <StyledFormControlLabel
                            name={ReasonForLess.Repetitive}
                            value={ReasonForLess.Repetitive}
                            label={t('news:newsPost:reasonForLess:repetitive')}
                            control={<Radio />}
                        />
                        <StyledFormControlLabel
                            name={ReasonForLess.Enough}
                            value={ReasonForLess.Enough}
                            label={t('news:newsPost:reasonForLess:enough')}
                            control={<Radio />}
                        />
                    </RadioGroup>
                </StyledDialogContent>
            </Box>
        </StyledDialog>
    );
};

export default SendNewsFeedbackModal;
